import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import backend_url from "../../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class NationalPerformanceReport extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      GraphicalData: [],
      bearer_auth: window.sessionStorage.getItem('token'),
      loading: true,
      error: null,
      chartOptions: {
        chart: {
          toolbar: { show: false },
        },
        colors: ['#FF8C00'],
        plotOptions: {
          bar: {
            columnWidth: '45%',
            dataLabels: { show: false }
          }
        },
        legend: { show: true },
        dataLabels: { enabled: false },
        grid: {
          borderColor: '#f8f8fa',
          row: { colors: ['transparent', 'transparent'] }
        },
        stroke: {
          show: true,
          width: 1.5,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
          axisBorder: { show: false },
          axisTicks: { show: false },
          title: { text: 'DIVISION NAME(S)' }
        },
        yaxis: {
          title: { text: 'AVERAGE ACHIEVEMENT COUNT' }
        }
      },
      series: [{ name: 'Average Achievement Count', data: [] }]
    };
  }
  
  componentDidMount() {
    this.fetchData();
  }
  
  fetchData() {
    const { bearer_auth } = this.state;
    
    if (!bearer_auth) {
      this.setState({ 
        error: 'No authentication token',
        loading: false 
      });
      return;
    }
    
    axios.get(`${API_URL}/key_evidences/perf/national`, {
      headers: { "Authorization": `Bearer ${bearer_auth}` }
    })
    .then(response => {
      const data = response.data || [];
      this.processData(data);
    })
    .catch(error => {
      console.error('Error loading performance data:', error);
      this.setState({ 
        error: 'Failed to load data',
        loading: false 
      });
    });
  }
  
  processData(GraphicalData) {
    const categories = [];
    const values = [];
    
    for (let i = 0; i < GraphicalData.length; i++) {
      if (GraphicalData[i]['division_name'] && GraphicalData[i]['AVERAGE'] !== undefined) {
        categories.push(GraphicalData[i]['division_name']);
        values.push(parseFloat(GraphicalData[i]['AVERAGE']) || 0);
      }
    }
    
    this.setState(prevState => ({
      GraphicalData,
      loading: false,
      chartOptions: {
        ...prevState.chartOptions,
        xaxis: { ...prevState.chartOptions.xaxis, categories }
      },
      series: [{ name: 'Average Achievement Count', data: values }]
    }));
  }
  
  render() {
    const { chartOptions, series, loading, error } = this.state;
    
    if (loading) {
      return <div className="text-center p-3">Loading...</div>;
    }
    
    if (error) {
      return <div className="text-center p-3 text-danger">{error}</div>;
    }
    
    return (
      <React.Fragment>
        <ReactApexChart 
          options={chartOptions} 
          series={series} 
          type="bar" 
          height="290" 
        />
      </React.Fragment>
    );
  }
}

export default NationalPerformanceReport;